<div class="container-fluid">
  <app-page-header
    icon="fe-bar-chart-2"
    pretitle="Registo"
    title="Estatísticas de ocorrências"
    description="Distribuição por tipo, origem, estado e cumprimento de prazos — filtrável por ano e por âmbito/subâmbito."
  >
    <a actions class="btn btn-white" routerLink="../ocorrencias">Voltar</a>
  </app-page-header>
</div>

<div class="container-fluid">
  <!-- Filtros (estilo slicer): ano + âmbito/subâmbito -->
  <div class="card">
    <div class="card-body py-3">
      <div class="row g-3">
        <div class="col-6 col-md-3">
          <label class="form-label small text-muted mb-1">Ano</label>
          <select class="form-select" [(ngModel)]="year" (ngModelChange)="load()" data-no-filter>
            @for (option of years(); track option) { <option [ngValue]="option">{{ option }}</option> }
          </select>
        </div>
        <div class="col-6 col-md-3">
          <label class="form-label small text-muted mb-1">Âmbito</label>
          <select class="form-select" [(ngModel)]="scope" (ngModelChange)="onScopeChange()" data-no-filter>
            <option [ngValue]="null">Todos</option>
            @for (option of scopeOptions; track option.value) { <option [ngValue]="option.value">{{ option.label }}</option> }
          </select>
        </div>
        @if (scope) {
          <div class="col-6 col-md-3">
            <label class="form-label small text-muted mb-1">Subâmbito</label>
            <select class="form-select" [(ngModel)]="subScope" (ngModelChange)="load()" data-no-filter>
              <option [ngValue]="null">Todos</option>
              @for (option of subScopeFilterOptions(); track option.value) { <option [ngValue]="option.value">{{ option.label }}</option> }
            </select>
          </div>
        }
      </div>
    </div>
  </div>

  @if (error()) {
    <div class="alert alert-danger">{{ error() }}</div>
  } @else if (loading()) {
    <p class="text-muted text-center py-6">A carregar…</p>
  } @else if (stats(); as data) {
    <!-- Ao mudar um filtro os gráficos ficam onde estão e só esmorecem: os dados novos entram
         por cima, animados, e vê-se as barras crescer ou encolher. Trocá-los por um texto fazia
         a página piscar e perdia-se a comparação com o que lá estava. -->
    <div [class.stats-refreshing]="refreshing()">

    @if (data.total > 0 && data.total < 3) {
      <!-- Com um ou dois registos os gráficos leem-se mal (donut a 100%, eixo de 0 a 1). -->
      <div class="alert alert-light border d-flex align-items-center gap-2">
        <i class="fe fe-info text-muted"></i>
        <span class="small">
          Poucos registos no período ({{ data.total }}): as percentagens e as distribuições abaixo
          só ganham significado com mais ocorrências.
        </span>
      </div>
    }

    <!-- KPIs -->
    <div class="row">
      <div class="col-6 col-md-4">
        <div class="card"><div class="card-body">
          <div class="row align-items-center gx-0">
            <div class="col">
              <h6 class="text-uppercase text-muted mb-2">Total no ano</h6>
              <span class="h1 mb-0">{{ data.total }}</span>
            </div>
            <div class="col-auto"><span class="kpi-icon kpi-icon--primary"><i class="fe fe-alert-triangle"></i></span></div>
          </div>
        </div></div>
      </div>
      <div class="col-6 col-md-4">
        <div class="card"><div class="card-body">
          <div class="row align-items-center gx-0">
            <div class="col">
              <h6 class="text-uppercase text-muted mb-2">Eficácia avaliada dentro do prazo</h6>
              <span class="h1 mb-0">{{ data.effectivenessOnTime }}</span>
              <p class="small text-muted mb-0">ocorrências avaliadas até à data esperada</p>
            </div>
            <div class="col-auto"><span class="kpi-icon kpi-icon--success"><i class="fe fe-check-circle"></i></span></div>
          </div>
        </div></div>
      </div>
      <div class="col-6 col-md-4">
        <div class="card"><div class="card-body">
          <div class="row align-items-center gx-0">
            <div class="col">
              <h6 class="text-uppercase text-muted mb-2">Eficácia avaliada fora do prazo</h6>
              <span class="h1 mb-0">{{ effectivenessLate() }}</span>
              <p class="small text-muted mb-0">de {{ data.effectivenessDone }} avaliações feitas</p>
            </div>
            <div class="col-auto"><span class="kpi-icon kpi-icon--danger"><i class="fe fe-clock"></i></span></div>
          </div>
        </div></div>
      </div>
      <div class="col-6 col-md-4">
        <div class="card"><div class="card-body">
          <div class="row align-items-center gx-0">
            <div class="col">
              <h6 class="text-uppercase text-muted mb-2">Reclamações recorrentes</h6>
              <span class="h1 mb-0">{{ data.recurringComplaints }}</span>
              <p class="small text-muted mb-0">marcadas como repetição de um caso anterior</p>
            </div>
            <div class="col-auto"><span class="kpi-icon kpi-icon--warning"><i class="fe fe-repeat"></i></span></div>
          </div>
        </div></div>
      </div>
      <div class="col-12 col-md-4">
        <div class="card"><div class="card-body">
          <div class="row align-items-center gx-0">
            <div class="col">
              <h6 class="text-uppercase text-muted mb-2">Tipos distintos</h6>
              <span class="h1 mb-0">{{ data.byType.length }}</span>
            </div>
            <div class="col-auto"><span class="kpi-icon kpi-icon--info"><i class="fe fe-layers"></i></span></div>
          </div>
        </div></div>
      </div>
    </div>

    <div class="row">
      <!-- Tipo de ocorrência: barras + linha % -->
      <div class="col-12 col-lg-7">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-primary-soft text-primary"><i class="fe fe-layers"></i></span></span>
              <h4 class="card-header-title mb-0">Tipo de ocorrência</h4>
            </div>
            <span class="badge bg-secondary-soft d-none d-sm-inline-block">contagem + % do total</span>
          </div>
          <div class="card-body">
            @if (data.byType.length === 0) { <p class="text-muted mb-0">Sem dados.</p> }
            @else { <app-echart
                [options]="typeCombo()"
                [height]="320"
                (pointClick)="onChartPoint($event, 'Tipo de ocorrência')"
              /> }
          </div>
        </div>
      </div>

      <!-- Ocorrências por origem: donut -->
      <div class="col-12 col-lg-5">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-info-soft text-info"><i class="fe fe-pie-chart"></i></span></span>
              <h4 class="card-header-title mb-0">Ocorrências por origem</h4>
            </div>
          </div>
          <div class="card-body">
            @if (data.byOrigin.length === 0) { <p class="text-muted mb-0">Sem dados.</p> }
            @else { <app-echart
                [options]="originDonut()"
                [height]="320"
                (pointClick)="onChartPoint($event, 'Ocorrências por origem')"
              /> }
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Estado × origem: empilhadas -->
      <div class="col-12 col-lg-7">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-secondary-soft text-secondary"><i class="fe fe-grid"></i></span></span>
              <h4 class="card-header-title mb-0">Cruzamento com a origem</h4>
            </div>
            <select class="form-select form-select-sm" style="width: auto"
                    [(ngModel)]="crossDimension" data-no-filter>
              <option value="type">Por tipo</option>
              <option value="nature">Por natureza</option>
              <option value="state">Por estado</option>
            </select>
          </div>
          <div class="card-body">
            @if (data.byStateAndOrigin.length === 0) { <p class="text-muted mb-0">Sem dados no período.</p> }
            @else { <app-echart
                [options]="crossOriginStack()"
                [height]="320"
                (pointClick)="onChartPoint($event, 'Cruzamento com a origem')"
              /> }
          </div>
        </div>
      </div>

      <!-- Fechadas dentro do prazo por origem -->
      <div class="col-12 col-lg-5">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-success-soft text-success"><i class="fe fe-clock"></i></span></span>
              <h4 class="card-header-title mb-0">Fechadas dentro do prazo</h4>
            </div>
            <span class="badge bg-secondary-soft d-none d-sm-inline-block">prazo de implementação</span>
          </div>
          <div class="card-body">
            @if (data.closedWithinDeadlineByOrigin.length === 0) { <p class="text-muted mb-0">Sem ocorrências fechadas.</p> }
            @else { <app-echart
                [options]="deadlineByOrigin()"
                [height]="320"
                (pointClick)="onChartPoint($event, 'Fechadas dentro do prazo')"
              /> }
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Natureza: é o corte que separa reclamações e denúncias do resto -->
      <div class="col-12 col-lg-4">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-danger-soft text-danger"><i class="fe fe-message-square"></i></span></span>
              <h4 class="card-header-title mb-0">Natureza da participação</h4>
            </div>
          </div>
          <div class="card-body">
            @if (data.byNature.length === 0) { <p class="text-muted mb-0">Sem participações no período.</p> }
            @else { <app-echart
                [options]="natureDonut()"
                [height]="300"
                (pointClick)="onChartPoint($event, 'Natureza da participação')"
              /> }
          </div>
        </div>
      </div>

      <!-- Motivo das reclamações -->
      <div class="col-12 col-lg-4">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-warning-soft text-warning"><i class="fe fe-thumbs-down"></i></span></span>
              <h4 class="card-header-title mb-0">Motivo das reclamações</h4>
            </div>
          </div>
          <div class="card-body">
            @if (data.byComplaintReason.length === 0) { <p class="text-muted mb-0">Sem reclamações no período.</p> }
            @else { <app-echart
                [options]="complaintReasonBars()"
                [height]="300"
                (pointClick)="onChartPoint($event, 'Motivo das reclamações')"
              /> }
          </div>
        </div>
      </div>

      <!-- Resultado da avaliação da eficácia -->
      <div class="col-12 col-lg-4">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-success-soft text-success"><i class="fe fe-award"></i></span></span>
              <h4 class="card-header-title mb-0">Resultado da eficácia</h4>
            </div>
          </div>
          <div class="card-body">
            @if (data.byEffectiveness.length === 0) { <p class="text-muted mb-0">Sem avaliações registadas.</p> }
            @else { <app-echart
                [options]="effectivenessDonut()"
                [height]="300"
                (pointClick)="onChartPoint($event, 'Resultado da eficácia')"
              /> }
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Prazo por tipo: o mesmo corte do prazo, do lado do tipo -->
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-success-soft text-success"><i class="fe fe-clock"></i></span></span>
              <h4 class="card-header-title mb-0">Fechadas dentro do prazo, por tipo</h4>
            </div>
            <span class="badge bg-secondary-soft d-none d-sm-inline-block">prazo de implementação</span>
          </div>
          <div class="card-body">
            @if (data.closedWithinDeadlineByType.length === 0) { <p class="text-muted mb-0">Sem ocorrências fechadas.</p> }
            @else { <app-echart
                [options]="deadlineByType()"
                [height]="320"
                (pointClick)="onChartPoint($event, 'Fechadas dentro do prazo, por tipo')"
              /> }
          </div>
        </div>
      </div>
    </div>

    <!-- Small multiples: tipo de ocorrência por ano -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-warning-soft text-warning"><i class="fe fe-calendar"></i></span></span>
              <h4 class="card-header-title mb-0">Tipo de ocorrência por ano</h4>
            </div>
            <span class="badge bg-secondary-soft d-none d-md-inline-block">últimos 4 anos · 6 tipos mais frequentes por ano · ignora o filtro de ano</span>
          </div>
          <div class="card-body">
            @if (data.byTypeAndYear.length === 0) { <p class="text-muted mb-0">Sem dados.</p> }
            @else { <app-echart
                [options]="typeByYearMultiples()"
                [height]="440"
                (pointClick)="onChartPoint($event, 'Tipo de ocorrência por ano')"
              /> }
          </div>
        </div>
      </div>
    </div>
    </div>
  }
</div>

<!--
  O gráfico responde a "quantos"; a pergunta a seguir é sempre "quais". Clicar num pedaço abre
  esta lista com as ocorrências que o compõem, e cada uma leva à sua página.

  O recorte é o do pedaço mais o da página (ano, âmbito): é preciso contar o mesmo que o
  gráfico contou, senão os números não batem certo com o que se acabou de ver.
-->
@if (drillOpen()) {
  <div class="stat-drill-backdrop" (click)="closeDrill()"></div>
  <aside class="stat-drill" role="dialog" aria-modal="true" [attr.aria-label]="drillTitle()"
         animate.enter="app-slide-in-right" animate.leave="app-slide-out-right">
    <header class="stat-drill-head">
      <div class="stat-drill-titles">
        <span class="stat-drill-pretitle">Detalhe da métrica</span>
        <h2 class="stat-drill-title">{{ drillTitle() }}</h2>
      </div>
      <button class="stat-drill-close" type="button" aria-label="Fechar" (click)="closeDrill()">
        <i class="fe fe-x"></i>
      </button>
    </header>

    <div class="stat-drill-body">
      @if (drillLoading()) {
        <p class="text-muted p-4 mb-0 text-center">A carregar…</p>
      } @else if (drillItems().length === 0) {
        <div class="stat-drill-empty">
          <span class="stat-drill-empty-icon"><i class="fe fe-inbox"></i></span>
          <p class="stat-drill-empty-title">Nenhuma ocorrência</p>
          <p class="stat-drill-empty-text">
            Este recorte não devolveu registos — pode ser que o gráfico conte por uma data
            diferente da que a lista usa.
          </p>
        </div>
      } @else {
        <span class="stat-drill-count">
          {{ drillTotal() }} {{ drillTotal() === 1 ? 'ocorrência' : 'ocorrências' }}
        </span>
        <div class="list-group list-group-flush">
          @for (item of drillItems(); track item.id) {
            <a class="list-group-item list-group-item-action stat-drill-item"
               [routerLink]="['..', 'ocorrencias', item.id]" (click)="closeDrill()">
              <span class="stat-drill-item-main">
                <span class="stat-drill-item-title">{{ item.title }}</span>
                <span class="stat-drill-item-sub">
                  {{ item.code }} · {{ typeLabel(item.type) }}
                  @if (item.nature) { · {{ natureLabel(item.nature) }} }
                  · {{ originLabel(item.origin) }}
                </span>
              </span>
              <i class="fe fe-chevron-right stat-drill-item-go"></i>
            </a>
          }
        </div>
        @if (drillHidden() > 0) {
          <p class="stat-drill-more">
            Mostram-se as {{ drillItems().length }} mais recentes; faltam {{ drillHidden() }}.
            Use os filtros da lista para as ver todas.
          </p>
        }
      }
    </div>
  </aside>
}
